import { money, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fetchDisputeTransactionsList = gql`
  query FetchDisputeTransactionsList(
    $disputeId: ID!
    $first: Int!
    $after: String!
  ) {
    disputeTransactions(disputeId: $disputeId, first: $first, after: $after) {
      edges {
        node {
          id
          createdAt
          description
          value {
            ...money
          }
        }
        cursor
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${money}
  ${pageInfo}
`;

export default fetchDisputeTransactionsList;
